import React from 'react';
import { Card, CardContent, Typography, Box, Link as MuiLink, CircularProgress } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface DashboardWidgetProps {
    title: string
    count: number | undefined;
    description: string;
    link: string;
}

const DashboardWidget: React.FC<DashboardWidgetProps> = ({ title, count, description, link }) => {
    return (<MuiLink component={RouterLink} to={link} style={{ textDecoration: 'none' }}>

        <Card sx={{ width: 320, height: 150, margin: 2, boxShadow: 3, display: 'inline-block' }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6" component="div">
                        {title}
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 42 }}>
                        {count !== undefined ? (
                            <Typography variant="h4" color="primary" fontWeight="bold">
                                {count}
                            </Typography>
                        ) : (
                            <CircularProgress size={24} />
                        )}
                    </Box>
                </Box>
                <Typography variant="body2" color="textSecondary">
                    {description}
                </Typography>
            </CardContent>
        </Card>
    </MuiLink >
    );
};

export default DashboardWidget;
